// A move that asks first: a counterparty's return, rejection or override (TX-US-0042), a deal's
// reopening, cancellation, return or rejection (TX-US-0043). Each dialog is its own fields over
// this one, which holds what they share - the busy state, the refusal shown beside the control
// refused, and what the move wrote, handed back to the caller. `refusal(err)` puts a refusal in
// the screen's words: what is refused, and what is stale, differs by record.

import { useState } from 'react';

import Modal from './Modal.jsx';

export default function MoveDialog({
  title, hint, submitLabel, busyLabel, danger, ready, move, refusal, onClose, onMoved, children,
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const moved = await move();
      onMoved?.(moved);
    } catch (err) {
      setError(refusal(err));
      setBusy(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <form onSubmit={onSubmit}>
        <h3>{title}</h3>
        {hint && <p className="hint">{hint}</p>}
        {children}
        {error && <p className="error">{error}</p>}
        <menu>
          <button type="button" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" className={danger ? 'danger' : undefined} disabled={busy || !ready}>
            {busy ? busyLabel : submitLabel}
          </button>
        </menu>
      </form>
    </Modal>
  );
}

// The reason a move asks for, as every dialog here asks it.
export function ReasonField({ label = 'Reason', value, onChange, maxLength }) {
  return (
    <label>
      {label}
      <textarea value={value} onChange={(event) => onChange(event.target.value)} required
                maxLength={maxLength} autoFocus />
    </label>
  );
}
